import React, {Component} from 'react';

import axios from "axios";
import AuthService from "../../AuthService";
import Table from 'react-bootstrap/Table';
import DatePicker from "react-datepicker";

import {Grid} from 'react-loader-spinner'
import {withRouter} from "react-router-dom";

import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment/moment";

import Dialog from "../util/Dialog";
import authService from "../../AuthService";

class Reservations extends Component {

    constructor(props) {
        super(props);

        this.state = {
            croisiereList: {},
            pageNumber: 1,
            result: null,
            searchValue: '',
            selectedVille: 0,
            selectedBateau: null,
            selectedCapitaine: null,
            villeList: {},
            bateauList: {},
            capitaineList: {},
            croisiereRefStatutList: {},
            selectedCroisiereStatut: null,
            croisiereTypeList: {},
            croisiereTypeListForExport: [],
            croisieresSoldFilter: false,
            selectedCroisiereType: null,
            selectedDate: null,
            croisiereTotalNumber: null,
            totalPageNumber: null,
            columnSorted: {column: 'id', order: 'desc'},
            showExport: false,
            exportBeginDate : null,
            exportEndDate : null,
            exportBateau: null,
            exportVille: 0,
            exportCroisiereStatut: null,
            exportCroisiereType: null,
        }
    }


    async componentDidMount() {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        if (!!queryParameters.get("selectedDate")) {
            await this.setState({
                selectedDate: formatUTC(decodeURIComponent(queryParameters.get("selectedDate")))
            });
        }
        if (!!queryParameters.get("selectedVille")) {
            await this.setState({
                selectedVille: queryParameters.get("selectedVille")
            });
        }
        if (!!queryParameters.get("selectedBateau")) {
            await this.setState({
                selectedBateau: queryParameters.get("selectedBateau")
            });
        }
        if (!!queryParameters.get("selectedCapitaine")) {
            await this.setState({
                selectedCapitaine: queryParameters.get("selectedCapitaine")
            });
        }
        if (!!queryParameters.get("selectedCroisiereStatut")) {
            await this.setState({
                selectedCroisiereStatut: queryParameters.get("selectedCroisiereStatut")
            });
        }
        if (!!queryParameters.get("selectedCroisiereType")) {
            await this.setState({
                selectedCroisiereType: queryParameters.get("selectedCroisiereType")
            });
        }
        if (!!queryParameters.get("croisieresSoldFilter")) {
            await this.setState({
                croisieresSoldFilter: queryParameters.get("croisieresSoldFilter")
            });
        }

        await this.loadData(false);
    }

    async loadData() {
        if(this.state.selectedVille == 0) {
            this.state.selectedBateau = 0
        }
        this.setState({loading: true});
        await axios.post(AuthService.getUrl("/reservations"), {
            pageNumber: this.state.pageNumber,
            selectedVille: this.state.selectedVille,
            selectedCroisiereStatut: this.state.selectedCroisiereStatut,
            selectedCroisiereType: this.state.selectedCroisiereType,
            selectedBateau: this.state.selectedBateau,
            selectedCapitaine: this.state.selectedCapitaine,
            selectedDate: this.state.selectedDate,
            searchValue: this.state.searchValue,
            columnSorted: this.state.columnSorted,
            croisieresSoldFilter: this.state.croisieresSoldFilter,
            userId: authService.decodeToken(authService.getToken()).id
        }, AuthService.getAuthHeader(this.state.locale)).then(async res => {
            if(!res.data.data.villeList || res.data.data.villeList.length == 0){
                const res = await authService.getUserById();
                const isCapitaine = res.data.data.capitaine === "oui";
                if(isCapitaine){
                    alert("Vous n'êtes associé à aucune ville, veuillez contacter l'administration !");
                    authService.disconnect();
                    this.props.history.push('/admin');
                } else {
                    alert("Vous n'êtes associé à aucune ville, veuillez contacter l'administration !");
                    this.props.history.push('/admin/utilisateurs');
                }
            }
            await this.setState({
                result: res.return,
                croisiereList: res.data.data.croisiereList,
                villeList: res.data.data.villeList,
                croisiereRefStatutList: res.data.data.croisiereStatutList,
                bateauList: res.data.data.bateauList,
                capitaineList: res.data.data.capitaineList,
                croisiereTypeList: res.data.data.croisiereTypeList,
                croisiereTotalNumber: res.data.data.croisiereTotalNumber,
                totalPageNumber: res.data.data.totalPageNumber,
            });
        });
    }

    closeDialog = () => {
        this.setState({
            showExport: false
        });
    }

    openDialog = () => {
        this.setState({
            showExport: true
        });
    }

    render() {
        if (this.state.result === null) {
            return (
                <div id="reservationPage">
                    <div className="centerScreen">
                        <Grid
                            height="80"
                            width="80"
                            color="#4fa94d"
                            ariaLabel="grid-loading"
                            radius="12.5"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>
                </div>)
        } else {
            return (<div id="reservationPage">
                <div className="filters">

                    <div className="filter">
                        <label htmlFor="site-search">Recherche (Client, Adresse, Email, Téléphone, Société, Commentaire) :</label>
                        <input type="search" id="site-search" name="search"
                               onChange={this.updateSearchValue.bind(this)}
                               onKeyDown={(event) => this.handleOnKeyDown(event)}></input>
                        <button onClick={() => this.search()}>OK</button>
                    </div>

                    <div className="filter">
                        <label>Date :</label>
                        <DatePicker isClearable
                                    locale="fr-FR"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.selectedDate}
                                    style={{width: "200px"}}
                                    onChange={(date) => this.dateChange(date)}
                        />
                    </div>

                    <br></br>
                    <br></br>
                    <div className="filter">
                        <label>Ville :</label>
                        {<select className="value" type="text" name="ville" value={this.state.selectedVille} onChange={e => this.villeChange(e)}>
                            <option key={0} value={0}>---</option>
                            {this.state.villeList.map(ville => (
                                <option key={ville.id} value={ville.id}>{ville.nom}</option>
                            ))}
                        </select>}
                    </div>

                    <div className="filter">
                        <label>Capitaine :</label>
                        {<select className="value" type="text" name="capitaine" value={this.state.selectedCapitaine} onChange={e => this.capitaineChange(e)}>
                            <option key={0} value={0}>---</option>
                            {this.state.capitaineList.map(capitaine => (
                                <option key={capitaine.id} value={capitaine.id}>{capitaine.prenom + ' ' + capitaine.nom}</option>
                            ))}
                        </select>}
                    </div>

                    <div className="filter">
                        <label>Bateau :</label>
                        {<select className="value" type="text" name="bateau" value={this.state.selectedBateau} onChange={e => this.bateauChange(e)}>
                            <option key={0} value={0}>---</option>
                            {this.state.bateauList.map(bateau => (
                                <option key={bateau.id} value={bateau.id}>{bateau.nom}</option>
                            ))}
                        </select>}
                    </div>

                    <div className="filter">
                        <label>Statut :</label>
                        {<select className="value" type="text" name="croisiereStatut" onChange={e => this.croisiereStatutChange(e)}>
                            <option key={0} value={0}>---</option>
                            {this.state.croisiereRefStatutList.map(croisiereStatutRef => (
                                <option key={croisiereStatutRef.id} value={croisiereStatutRef.id}>{croisiereStatutRef.label}</option>
                            ))}
                        </select>}
                    </div>

                    <div className="filter">
                        <label>Type :</label>
                        {<select className="value" type="text" name="croisiereStatut" onChange={e => this.croisiereTypeChange(e)}>
                            <option key={0} value={0}>---</option>
                            {this.state.croisiereTypeList.map(croisiereType => (
                                <option key={croisiereType.id} value={croisiereType.id}>{croisiereType.label}</option>
                            ))}
                        </select>}
                    </div>

                    <div className="filter">
                        <label>Croisière soldée :</label>
                        <input type="checkbox" id="sold" name="sold" onChange={e => this.croisieresSold(e)}></input>
                    </div>

                    <div className="filter">
                        <button type="button" onClick={this.openDialog}>Exporter</button>
                    </div>

                </div>

                {<Table striped bordered hover className="reservationsGrid data-table">
                    <thead>
                    <tr>
                        <th className="headerSortDown sortable" onClick={() => this.sortByColumn('id')}>#</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('refCroisiereStatut.label')}>Statut</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('bateau.nom')}>Bateau</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('utilisateur.nom')}>Capitaine</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('clientPrenom')}>Client</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('croisiereType.duree')}>Durée</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('croisiereRamassage.labelId')}>Ramassage</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('nombrePassager')}>Nb Passagers</th>
                        <th className="headerSortUp sortable" onClick={() => this.sortByColumn('date')}>Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.croisiereList.map(croisiere => (<tr style={{"cursor": "pointer"}} key={croisiere.id}
                                                                    onClick={() => this.redirectCroisiereDetail(croisiere.id)}>
                        <td style={{"text-align": "left"}}>{croisiere.id}</td>
                        <td style={{"text-align": "left"}}
                            className={'croisiere-statut croisiere-statut-' + croisiere.refCroisiereStatut.id}>
                            <div style={{"margin-left": "10px"}}>
                                {this.getStatut(croisiere.refCroisiereStatut.id)}
                            </div>
                        </td>
                        <td style={{"text-align": "center"}}>{croisiere.bateau?.nom}</td>
                        {croisiere.utilisateur !== null &&
                            <td style={{"text-align": "center"}}>{croisiere.utilisateur?.prenom + ' ' + croisiere.utilisateur?.nom}</td>
                        }
                        {croisiere.utilisateur === null &&
                            <td style={{"text-align": "center"}}></td>
                        }
                        <td style={{"text-align": "center"}}>{croisiere?.clientPrenom + ' ' + croisiere?.clientNom}</td>
                        <td style={{"text-align": "right"}}>{this.convertDuree(croisiere.croisiereType.duree)}</td>
                        <td style={{"text-align": "center"}}>{croisiere?.croisiereRamassage?.label}</td>
                        <td style={{"text-align": "right"}}>{croisiere.nombrePassager}</td>
                        <td style={{"text-align": "right"}}>{croisiere.date}</td>
                    </tr>))}
                    </tbody>
                </Table>}

                <div className="data-table-pagination">
                    {this.state.pageNumber > 1 &&
                        <a className="pagination-button" id="previousPage" onClick={() => this.loadPage(-1)}>&laquo;</a>
                    }
                    <a id="pageNumber">{this.state.pageNumber}</a> / <a id="totalPageNumber">{this.state.totalPageNumber + 1}</a>
                    {this.state.pageNumber <= this.state.totalPageNumber &&
                        <a className="pagination-button" id="nextPage" onClick={() => this.loadPage(+1)}>&raquo;</a>
                    }
                    <a>{this.state.croisiereList.length} Croisières affichées</a>
                </div>

                {this.state.showExport &&
                    <Dialog close={this.closeDialog}>
                        <div style={{"width": "750px","height": "30px", "background" : "#234351"}}>
                            <span style={{"fontSize" : "20px","color" : "#FFFFFF", "fontWeight" : "bold", "paddingLeft" : "10px"}}>Export des données</span>
                        </div>
                        <div style={{"width": "750px","height": "250px", "background" : "#FFFFFF"}}>
                            <div className="filter" style={{"position" : "absolute", "left" : "10px", "top" : "45px"}}>
                                <label className="labelFormExportSearch">Date </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "70px", "top" : "45px"}}>
                                <label className="labelFormExportSearch"> du </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "90px", "top" : "45px"}}>
                                <DatePicker isClearable
                                            locale="fr-FR"
                                            dateFormat="dd/MM/yyyy"
                                            className="littleDatePicker"
                                            selected={this.state.exportBeginDate}
                                            onChange={(date) => this.dateDebutChange(date)}
                                />
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "210px", "top" : "45px"}}>
                                <label className="labelFormExportSearch"> au </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "230px", "top" : "45px"}}>
                                <DatePicker isClearable
                                            locale="fr-FR"
                                            dateFormat="dd/MM/yyyy"
                                            className="littleDatePicker"
                                            selected={this.state.exportEndDate}
                                            onChange={(date) => this.dateFinChange(date)}
                                />
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "400px", "top" : "45px"}}>
                                <label className="labelFormExportSearch"> Bateau </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "450px", "top" : "40px"}}>
                                {<select className="valueFormExportSearch" type="text" name="bateau" value={this.state.exportBateau} onChange={e => this.exportBateauChange(e)}>
                                    <option key={0} value={0}>---</option>
                                    {this.state.bateauList.map(bateau => (
                                        <option key={bateau.id} value={bateau.id}>{bateau.nom}</option>
                                    ))}
                                </select>}
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "10px", "top" : "95px"}}>
                                <label className="labelFormExportSearch"> Ville </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "70px", "top" : "90px"}}>
                                {<select className="valueFormExportSearch" type="text" name="ville" value={this.state.exportVille} onChange={e => this.exportVilleChange(e)}>
                                    <option key={0} value={0}>---</option>
                                    {this.state.villeList.map(ville => (
                                        <option key={ville.id} value={ville.id}>{ville.nom}</option>
                                    ))}
                                </select>}
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "400px", "top" : "95px"}}>
                                <label className="labelFormExportSearch"> Statut </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "450px", "top" : "90px"}}>
                                {<select className="valueFormExportSearch" type="text" name="croisiereStatut" value={this.state.exportCroisiereStatut}  onChange={e => this.exportStatutChange(e)}>
                                    <option key={0} value={0}>---</option>
                                    {this.state.croisiereRefStatutList.map(croisiereStatutRef => (
                                        <option key={croisiereStatutRef.id} value={croisiereStatutRef.id}>{croisiereStatutRef.label}</option>
                                    ))}
                                </select>}
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "10px", "top" : "145px"}}>
                                <label className="labelFormExportSearch"> Capitaine </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "70px", "top" : "140px"}}>
                                {<select className="valueFormExportSearch" type="text" name="capitaine" value={this.state.exportCapitaine} onChange={e => this.exportCapitaineChange(e)}>
                                    <option key={0} value={0}>---</option>
                                    {this.state.capitaineList.map(capitaine => (
                                        <option key={capitaine.id} value={capitaine.id}>{capitaine.prenom + ' ' + capitaine.nom}</option>
                                    ))}
                                </select>}
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "400px", "top" : "145px"}}>
                                <label className="labelFormExportSearch"> Type </label>
                            </div>
                            <div className="filter" style={{"position" : "absolute", "left" : "450px", "top" : "140px"}}>
                                {<select className="valueFormExportSearch" type="text" name="croisiereStatut"  value={this.state.exportCroisiereType} onChange={e => this.exportCroisiereTypeChange(e)}>
                                    <option key={0} value={0}>---</option>
                                    {this.state.croisiereTypeListForExport.map(croisiereType => (
                                        <option key={croisiereType.id} value={croisiereType.id}>{croisiereType.label}</option>
                                    ))}
                                </select>}
                            </div>


                            <div className="filter" style={{"position" : "absolute", "left" : "300px", "top" : "190px"}}>
                                <button type="submit" className="coreBlockItem-typeSubmitSearch"name="export" id="exportButton" style={{"width": "150px"}}
                                        onClick={this.export}>EXPORTER</button>
                            </div>


                        </div>
                    </Dialog>
                }
            </div>)
        }
    }

    getStatut(id) {
        return this.state.croisiereRefStatutList.find(croisiereStatut => croisiereStatut.id === id).label;
    }

    redirectCroisiereDetail(id) {
        this.props.history.push('/admin/croisiere/' + id);
    }

    async handleOnKeyDown(event) {
        if(event.keyCode === 13) {
            await this.loadData();
        }
    }

    export = () => {
        document.getElementById("exportButton").disabled = true;
        document.getElementById("exportButton").classList.add('coreBlockItem-typeSubmitSearchDisabled');
        document.getElementById("exportButton").classList.remove('coreBlockItem-typeSubmitSearch');
        document.getElementById("exportButton").innerText = 'En cours';

        var params = new URLSearchParams();

        //date debut
        if (this.state.exportBeginDate != null) {
            var date = new Date(this.state.exportBeginDate);
            var moment = Moment(date).format('DD/MM/YYYY');
            params.append("exportBeginDate", moment);
        } else {
            params.append("exportBeginDate", "");
        }
        //date fin
        if (this.state.exportEndDate != null) {
            var date = new Date(this.state.exportEndDate);
            var moment = Moment(date).format('DD/MM/YYYY');
            params.append("exportEndDate", moment);
        } else {
            params.append("exportEndDate", "");
        }
        //bateau
        if (this.state.exportBateau != null) {
            params.append("exportBateau", this.state.exportBateau);
        } else {
            params.append("exportBateau", "");
        }
        //ville
        if (this.state.exportVille != null) {
            params.append("exportVille", this.state.exportVille);
        } else {
            params.append("exportVille", "");
        }
        //statut
        if (this.state.exportCroisiereStatut != null) {
            params.append("exportCroisiereStatut", this.state.exportCroisiereStatut);
        } else {
            params.append("exportCroisiereStatut", "");
        }
        //capitaine
        if (this.state.exportCapitaine != null) {
            params.append("exportCapitaine", this.state.exportCapitaine);
        } else {
            params.append("exportCapitaine", "");
        }
        //type
        if (this.state.exportCroisiereType != null) {
            params.append("exportCroisiereType", this.state.exportCroisiereType);
        } else {
            params.append("exportCroisiereType", "");
        }
        //user
        params.append("exportUser", authService.decodeToken(authService.getToken()).id);

        fetch(AuthService.getUrl('/export?' + params.toString()), {
            method: 'GET',
            responseType: 'blob', // This is not a standard option; you might need to handle it differently
        })
            .then((response) => response.blob())
            .then((blob) => {
                // Create a blob URL and create a link element to trigger the download
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = blobUrl;
                a.download = 'exportation.xlsx'; // Set the desired file name with .xls extension
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(blobUrl);

                document.getElementById("exportButton").disabled = false;
                document.getElementById("exportButton").classList.add('coreBlockItem-typeSubmitSearch');
                document.getElementById("exportButton").classList.remove('coreBlockItem-typeSubmitSearchDisabled');
                document.getElementById("exportButton").innerText = 'EXPORTER';

            })
            .catch((error) => {
                console.error('Error fetching Excel file:', error);
                document.getElementById("exportButton").disabled = false;
                document.getElementById("exportButton").classList.add('coreBlockItem-typeSubmitSearch');
                document.getElementById("exportButton").classList.remove('coreBlockItem-typeSubmitSearchDisabled');
                document.getElementById("exportButton").innerText = 'EXPORTER';
            });
    }

    async updateSearchValue(e) {
        const search = e.target.value;
        await this.setState({searchValue: search})
    }

    async loadPage(nextPage) {
        const currentPageNumber = this.state.pageNumber;
        const newPageNumber = currentPageNumber + parseInt(nextPage)
        await this.setState({pageNumber: newPageNumber});
        await this.loadData()
    }

    async search() {
        await this.setState({pageNumber: 1})
        await this.loadData()
    }

    async villeChange(e) {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        await this.setState({selectedVille: e.target.value})
        queryParameters.delete("selectedVille");
        queryParameters.append("selectedVille", this.state.selectedVille);
        this.props.history.push('?' + queryParameters.toString());
        await this.setState({pageNumber: 1})
        await this.loadData()
    }

    async exportVilleChange(e) {
        this.setState({exportVille: e.target.value})
        await axios.post(AuthService.getUrl("/getCroisiereTypesForSelectedExportVille"), {
            selectedExportVille: e.target.value,
        }, AuthService.getAuthHeader(this.state.locale)).then(async res => {
            this.setState({croisiereTypeListForExport : res.data.data.croisiereTypeListForExport})
        });
    }

    async bateauChange(e) {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        await this.setState({selectedBateau: e.target.value})
        queryParameters.delete("selectedBateau");
        queryParameters.append("selectedBateau", this.state.selectedBateau);
        this.props.history.push('?' + queryParameters.toString());
        await this.setState({pageNumber: 1})
        await this.loadData()
    }

    async exportBateauChange(e) {
        await this.setState({exportBateau: e.target.value})
    }

    async capitaineChange(e) {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        await this.setState({selectedCapitaine: e.target.value})
        queryParameters.delete("selectedCapitaine");
        queryParameters.append("selectedCapitaine", this.state.selectedCapitaine);
        this.props.history.push('?' + queryParameters.toString());
        await this.setState({pageNumber: 1})
        await this.loadData()
    }

    async exportCapitaineChange(e) {
        await this.setState({exportCapitaine: e.target.value})
    }

    async croisiereStatutChange(e) {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        await this.setState({selectedCroisiereStatut: e.target.value})
        queryParameters.delete("selectedCroisiereStatut");
        queryParameters.append("selectedCroisiereStatut", this.state.selectedCroisiereStatut);
        this.props.history.push('?' + queryParameters.toString());
        await this.setState({pageNumber: 1})
        await this.loadData()
    }

    async exportStatutChange(e) {
        await this.setState({exportCroisiereStatut: e.target.value})
    }

    async croisiereTypeChange(e) {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        await this.setState({selectedCroisiereType: e.target.value});
        queryParameters.delete("selectedCroisiereType");
        queryParameters.append("selectedCroisiereType", this.state.selectedCroisiereType);
        this.props.history.push('?' + queryParameters.toString());
        await this.setState({pageNumber: 1})
        await this.loadData()
    }

    async exportCroisiereTypeChange(e) {
        await this.setState({exportCroisiereType: e.target.value});
    }

    async croisieresSold(e) {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        await this.setState({croisieresSoldFilter: !this.state.croisieresSoldFilter})
        queryParameters.delete("croisieresSoldFilter");
        queryParameters.append("croisieresSoldFilter", this.state.croisieresSoldFilter);
        this.props.history.push('?' + queryParameters.toString());
        await this.setState({pageNumber: 1})
        await this.loadData()
    }

    async dateDebutChange(e) {
        let selectedDate;
        if (e !== null) {
            selectedDate = formatUTC(e);
        } else {
            selectedDate = null;
        }
        await this.setState({exportBeginDate: selectedDate});
    }

    async dateFinChange(e) {
        let selectedDate;
        if (e !== null) {
            selectedDate =  formatUTC(e);
        } else {
            selectedDate = null;
        }
        await this.setState({exportEndDate: selectedDate});
    }


    async dateChange(e) {
        const location = this.props.location;
        const queryParameters = new URLSearchParams(location.search);

        let selectedDate;

        if (e !== null) {
            selectedDate = formatUTC(e);
            queryParameters.delete("selectedDate");
            queryParameters.append("selectedDate", Moment(e).format("YYYY-MM-DD"));
        } else {
            selectedDate = null;
            queryParameters.delete("selectedDate");
        }

        this.props.history.push('?' + queryParameters.toString());
        await this.setState({selectedDate: selectedDate});
        await this.setState({pageNumber: 1});
        await this.loadData();
    }

    async clearDate() {
        await this.setState({selectedDate: null})
    }

    convertDuree(duree) {
        switch (duree) {
            case 1:
                return '1h00'
            case 1.5:
                return '1h30';
            case 2:
                return '2h00';
            case 3:
                return '3h00';
            default:
                return duree;
        }
    }

    async sortByColumn(id) {
        let order = 'desc';

        if (this.state.columnSorted.order === 'desc')
            order = 'asc';

        await this.setState({columnSorted: {column: id, order: order}})
        await this.loadData()
    }
}
export const formatUTC = (dateInt, addOffset = false) => {
    let date = (!dateInt || dateInt.length < 1) ? new Date : new Date(dateInt);
    if (typeof dateInt === "string") {
        return date;
    } else {
        const offset = addOffset ? date.getTimezoneOffset() : -(date.getTimezoneOffset());
        const offsetDate = new Date();
        offsetDate.setTime(date.getTime() + offset * 60000)
        return offsetDate;
    }
}


export default withRouter(Reservations);
